(function() {

	class InstamapsConstants {
		constructor (){
			
		}
	}

	InstamapsConstants.t_polyline = "polyline";
	InstamapsConstants.t_polygon = "polygon";
	InstamapsConstants.t_marker = "marker";
	InstamapsConstants.t_multiple = "multiple";
	InstamapsConstants.t_point = "point";
	InstamapsConstants.t_multipoint = "multipoint";
	InstamapsConstants.t_linestring = "linestring";
	InstamapsConstants.t_multilinestring = "multilinestring";
	InstamapsConstants.t_multipolygon = "multipolygon";
	InstamapsConstants.default_line_style = {
		weight: 3,
		color: '#FF0000',
		opacity:1,
		lineCap:'round',
		lineJoin:'round'
	}
	InstamapsConstants.default_area_style = {
		weight: 3,
		opacity: 1,
		color: '#FF0000',
		fillColor: "rgb(255,196,0)",
		borderColor: '#FF0000',
		borderWidth: 3,
		fillOpacity: 0.5
	};
	InstamapsConstants.dibuix_punt = "dibuix_punt";

	if (typeof module !== 'undefined' && typeof module.exports !== 'undefined') {
		module.exports = InstamapsConstants;
	} else {
		window.InstamapsConstants = InstamapsConstants;
	}

})();